declare var Fingerprint2: any;
var isConsentTaken: boolean = false;
export default class CookieConsentService {

  private codeGenMetadata: any;

  constructor(codeGenMetadata: any) {
    this.codeGenMetadata = codeGenMetadata;
  }

  private getGranted(identifier: any, formEle: any) {
    if (identifier.type == "checkbox") {
      return identifier.consentValue === "checked"
        ? formEle.querySelector(identifier.selector).checked
        : !formEle.querySelector(identifier.selector).checked;
    } else {
      return (
        identifier.consentValue ===
        Array.prototype.slice
          .call(formEle.querySelectorAll(identifier.selector))
          .filter(function (r) {
            return r.checked;
          })[0].value
      );
    }
  }

  private postConsentedItems(consentedItem: any) {
    var xhr = new XMLHttpRequest();
    xhr.open(
      "POST",
      "https://app.securiti.ai/privaci/v1/consent/form/singleupload",
      false
    );
    xhr.setRequestHeader("Content-type", "application/json");
    xhr.setRequestHeader(
      "X-Auth-Token",
      "a2db6894-e792-4449-8ad0-5d140ea4ed4f"
    );

    xhr.onload = function () {
      if (this.status >= 200 && this.status < 300) {
        let resp = JSON.parse(xhr.response);
        if (resp.status === 0) {
          console.log("consent uploaded successfully");
        }
      } else {
        console.log("consent upload failed", this.status, xhr.statusText);
      }
      setTimeout(function () {
        isConsentTaken = false;
      }, 0);
    };
    xhr.onerror = function () {
      console.log("consent upload failed", this.status, xhr.statusText);
      setTimeout(function () {
        isConsentTaken = false;
      }, 0);
    };
    xhr.send(JSON.stringify(consentedItem));
  }

  private prepareConsentPayload (formEle: any) {
    var browserFingerPrint = "";
    let s: any = document.createElement("script");
    s.async = 1;
    s.src =
      "https://cdnjs.cloudflare.com/ajax/libs/fingerprintjs2/2.1.0/fingerprint2.js";
    let parent_node = document.head || document.body;
    parent_node.appendChild(s);
    s.addEventListener("load", function () {
      Fingerprint2.get(function (components: any) {
        browserFingerPrint = Fingerprint2.x64hash128(
          components
            .map(function (pair: any) {
              return pair.value;
            })
            .join(),
          31
        );
      });
    });
    if (!isConsentTaken) {
      isConsentTaken = true;
      const emailField =
       formEle.querySelector('[type = "email"]');
      let payload: any = {
        form_info: {
          subject_info: {},
        },
        consent_info: [],
        browser_finger_print: browserFingerPrint,
        policy_version: 1,
        form_property_id: this.codeGenMetadata.formPropertyId,
      };

      if (
        this.codeGenMetadata.consentIdentifiers.length === 1 &&
        this.codeGenMetadata.consentIdentifiers[0].name === "DefaultElementId"
      ) {
        let data: any = new Date().getTime() / 1000; 
        payload.consent_info.push({
          granted: true,
          timestamp: parseInt(data),
          property_id: parseInt(
            this.codeGenMetadata.consentIdentifiers[0].propertyId
          ),
        });
      } else {
        this.codeGenMetadata.consentIdentifiers.forEach((identifier: any) => {
          let data: any = new Date().getTime() / 1000; 
          const granted = this.getGranted(identifier, formEle);
          payload.consent_info.push({
            granted: granted,
            timestamp: parseInt(data),
            property_id: parseInt(identifier.propertyId),
          });
        });
      }

      this.codeGenMetadata.subjectIdentifiers.forEach((identifier: any) => {
        payload.form_info.subject_info[identifier.name] =
          (formEle.querySelector(identifier.selector) &&
            formEle.querySelector(identifier.selector).value) ||
          "";
        if (!payload.hasOwnProperty("uuid") && identifier.isPrimary) {
          payload.uuid = payload.form_info.subject_info[identifier.name] || "";
        }
      });
      return payload;
    }
  }

  public uploadConsent() {
    let payload = this.prepareConsentPayload(
      document.querySelector(this.codeGenMetadata.formSelector)
    );
    if (payload) {
      return this.postConsentedItems(payload);
    }
  }
}
